import * as React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { Heart } from 'lucide-mui';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../reducers';
import ActionButton from '../../plan/upgrade/ActionButton';
import usePlan from '../../plan/hooks/plan';
import { useUserTags } from '../../../hooks/useTags';
import ContactSalesDialog from '../../sales/ContactSalesDialog';

const RequestTrialButton = () => {
  const { t } = useTranslation();
  const { plan } = useSelector((state: RootState) => state);
  const { getTag } = useUserTags();
  const { isPlan } = usePlan();
  const [salesDialogOpen, setSalesDialogOpen] = React.useState(false);

  const userGoal = getTag('userGoal');
  const hasBusinessGoal = userGoal === 'business';
  const isFreePlan =
    !plan.subscription?.package ||
    plan.subscription.package === 'FREE_LOGGEDIN';
  const upgraded = isPlan(['GROWTH', 'BUSINESS', 'ENTERPRISE']);

  // Only show for free plan users with business goal who haven't upgraded
  if (!isFreePlan || !hasBusinessGoal || upgraded) {
    return null;
  }

  const handleClick = () => {
    setSalesDialogOpen(true);
  };

  const handleSalesDialogClose = () => {
    setSalesDialogOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <ActionButton
        startIcon={<Heart />}
        variant="outlined"
        color="secondary"
        size="medium"
        onClick={handleClick}
        sx={{ minWidth: 'unset', height: '40px' }}
        tooltipMessage={t('upgrade.tooltips.trial')}
      >
        {t('upgrade.buttons.requestTrial').replace(/ /g, '\u00A0')}
      </ActionButton>
      {salesDialogOpen && (
        <ContactSalesDialog
          onClose={handleSalesDialogClose}
          formSource="Dashboard - Request Trial"
        />
      )}
    </Box>
  );
};

export default RequestTrialButton;
